import {ChangeDetectionStrategy, Component, Injector} from '@angular/core';
import {PlayerContainer} from '../../player/player.container';
import {Observable, of, takeUntil} from 'rxjs';
import {catchError, delay, finalize, repeat, switchMap, tap} from 'rxjs/operators';
import {Log, LogTag} from "../../services/Log";

@Component({
  selector: 'app-playlist',
  template: '<div #component><template #playercontainer></template></div>',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HourlyBalancerComponent extends PlayerContainer {
  pages: any;
  index: number = -1;
  duration;
  startTime;
  gap = 0;
  fillGaps;
  curPlayed;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.editMode) {
          this.showMsg(playerObject.$.label, this.PREVIEW);
          return of(null);
        }


        this.pages = this.data.HourlyBalancer[0].Page;
        this.fillGaps = (this.data.HourlyBalancer[0].$.fillGaps=="1");
        let totalPlay = 0;
        let totalItems = 0;
        if (this.pages!=null) {
          this.pages.forEach(page => {
            page.count = 0;
            totalPlay += Number(page.$.repetitions) * Number(page.$.duration);
            totalItems += Number(page.$.repetitions);
          })
        }
        this.gap = Math.max(0, (3600-totalPlay) / totalItems);
        this.curPlayed = 0;
        this.index = -1;
        this.startTime = new Date().getTime();

        this.loadStat();

        return of('a');
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  getIndex() {
    const time = ((new Date().getTime() - this.startTime) / 1000);
    while (true) {
      this.index++;
      if (this.index==this.pages.length) {
        this.index = 0;
      }
      const page = this.pages[this.index];
      const repetitions = Number(page.$.repetitions);
      const step = 3600 / repetitions;
      const duration = Number(page.$.duration);
      const count = time / step;
      if (page.count<=count) {
        page.count++;
        this.curPlayed += (duration + this.gap);
        break;
      }
    }
  }

  getPage(): Observable<any> {
    const logInfo = Log.getLogInfo("HourlyBalancerComponent", "getPage", []);
    if (this.pages==null || this.pages.length==0) {
      Log.d(logInfo, LogTag.PLAYER, 'no pages');
      this.showMsg(this.playerObject.$.label, 'Playlist is empty');
      return of(null);
    } else {
      this.showMsg(null, null);
      this.getIndex();
      const page = this.pages[this.index];
      let player = page.Player[0];
      this.duration = Number(page.$.duration);
      return of(player);
    }
  }


  play(): Observable<any> {
    if (this.pages==null || this.pages.length==0) {
      return of('a');
    }

    return of('loop').pipe(
      switchMap(r1 => this.showPage()),
      switchMap( a=> of('delay').pipe(delay(this.duration * 1000))),
      switchMap( r => {
        if (this.fillGaps==false && this.childComponent != null && this.gap > 10) {
          const oldChildComponent = this.childComponent;
          this.childComponent = null;
          return oldChildComponent.unload().pipe(
            tap( child => {
              const duration = Number(((new Date().getTime() - this.statStart) / 1000).toFixed(2));
              this.unloadComplete(child, duration)
            }),
            finalize(() => {
              if (oldChildComponent.finish$!=null) {
                oldChildComponent.finish$.next("finish");
                oldChildComponent.finish$.complete();
                oldChildComponent.finish$ = null;
              }
              oldChildComponent.destroy();
              this.removeComponent(oldChildComponent);
            })
          )
        }
        return of('next')
      }),
      delay(this.gap * 1000),
      repeat()
    );
  }

}
